/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Admin_Funnel_RangeInputs */

const en_admin_funnel_range = /** @type {(inputs: Admin_Funnel_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last ${i?.days} days`)
};

/**
* | output |
* | --- |
* | "Last {days} days" |
*
* @param {Admin_Funnel_RangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_range = /** @type {((inputs: Admin_Funnel_RangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_RangeInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_range(inputs)
});
export { admin_funnel_range as "admin.funnel.range" }